module.exports = __webpack_public_path__ + "static/img/wxgzh.eb61810.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wxgzh.jpg
// module id = JtxY
// module chunks = 1